import { atom } from "recoil";

const dropdownNotificationStore = atom<boolean>({
	key: "dropdownNotification",
	default: false,
});

export default dropdownNotificationStore;
